import { consume, ContextType } from '@lit/context';
import { css, html, LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { contexts } from '../contexts.js';
import { PageOrganization } from '../page-organization.js';
import { linkStyles } from './cssstyles.js';

@customElement('org-restrictions-banner')
class OrgRestrictionsBanner extends LitElement {

  @consume({ context: contexts.org, subscribe: true }) private _org?: ContextType<typeof contexts.org>;

  render() {
    const org = this._org;
    if (!org)
      return nothing;
    if (!org.restrictedCIUploads && !org.restrictedProjectAccess)
      return nothing;
    return html`
      <section>
        <sl-icon name=exclamation-triangle-fill></sl-icon>
        Organization <strong>${org.orgSlug}</strong> has access restrictions.
        <a href=${PageOrganization.url({ orgSlug: org.orgSlug })}>Details</a>
        <sl-icon name=exclamation-triangle-fill></sl-icon>
      </section>
    `;
  }

  static styles = [linkStyles, css`
    section {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: var(--sl-spacing-2x-small);
      padding: var(--sl-spacing-2x-small);
      background-color: var(--sl-color-danger-600);
      color: white;
      font-weight: var(--sl-font-weight-semibold);
    }

    sl-icon {
      font-size: var(--sl-font-size-large);
    }

    a {
      color: white;
      text-decoration: underline;
    }
  `];
}
